/**
 * Nextcloud - filepicker
 *
 *
 * This file is licensed under the Affero General Public License version 3 or
 * later. See the COPYING file.
 *
 * @author Julien Veyssier <eneiluj@posteo.net>
 * @copyright Julien Veyssier 2020
 */

import Vue from 'vue'
import ExampleApp from './views/ExampleApp.vue'

const View = Vue.extend(ExampleApp)
new View().$mount('#mount_point')
